import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './i18n';
import { router } from './routes';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './design-system/global.css';
import 'driver.js/dist/driver.css';
import './design-system/tutorial/tutorial.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<RouterProvider router={router} future={{ v7_startTransition: true }} />);

serviceWorkerRegistration.register();
